/** Zonas del parte de heridas — espejo de server/config/woundTiers.js. */
export const WOUND_ZONE_ORDER = ['head', 'chest', 'hands', 'legs', 'feet']

export const WOUND_ZONE_LABELS = {
  head: 'Cabeza',
  chest: 'Torso',
  hands: 'Manos',
  legs: 'Piernas',
  feet: 'Pies',
}

export const WOUND_SEVERITY_LABELS = {
  minor: 'Lesiones leves',
  serious: 'Grave',
  critical: 'Muy grave',
}
